<div
  (click)="onTableClick($event)"
  *ngIf="data && data.length > 0"
  [class]="'table-container '+cssClass"
  [ngClass]="{'apply-colors-to-columns': serviceName === 'favourites'}"
>

  <iv-live-header
    *ngIf="!isPreset"
    statistic
    statisticElementName="Click check box header table"
    (allRowsSelected)="emitAllRowsSelectionChange($event)"
    [allChecked]="allChecked"
    [row]="header"
    [isPreset]="isPreset"
    class="table-header"
    style="display: flex;flex-direction: row"
  ></iv-live-header>

  <iv-live-preset-header
  *ngIf="isPreset"
  statistic
  statisticElementName="Click check box header table"
  [row]="header"
  [isPreset]="isPreset"
  class="table-header"
  style="display: flex;flex-direction: row"
  (onSymbolSortChanged)="sortPresetBySymbol($event)"
></iv-live-preset-header>

  <div class="table-body-container grid-table-body-container">
    <cdk-virtual-scroll-viewport
      (scroll)="onTableScroll($event)"
      [minBufferPx]="scrollBuffer"
      class="table-body"
      [class.off-scroll]="offScroll"
      itemSize="27"
    >

      <div
        *cdkVirtualFor="let row of data; index as j; trackBy: trackByFn;"
        [class.selected]="row.selected"
        class="table-row"
      >

        <div
          *ngFor="let column of header"
          [attr.data-index]="j"
          [ngSwitch]="column.template"
          [style.width.px]="(column.width)"
          class="{{column.dataField}}_cell_row"
          [ngStyle]="column.template === 'number' ? {'overflow':'visible'} : null"
          [ngClass]="{'divider': serviceName === 'favourites'}"
        >

          <ng-container *ngSwitchDefault>
            {{row[column.dataField]}}
          </ng-container>

          <ng-container *ngSwitchCase="'checkbox'">
            <div
              (click)="clickCheckBox(j)"
              statistic
              statisticElementName="Click checkbox grid"
              style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;"
            >
              <label class="container">
                <input
                  [checked]="row.selected"
                  type="checkbox"
                >
                <span class="checkmark"></span>
              </label>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'date'">
            {{row[column.dataField] | date:'MM/dd/yyyy'}}
          </ng-container>

          <ng-container *ngSwitchCase="'number'">
            <span *ngIf="row[column.dataField] && row[column.dataField] !== 'Infinity' && row[column.dataField] !== NaN">
              {{+row[column.dataField] | number:'1.0-2'}}
            </span>
            <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivp') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              N/A
            </span>
            <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivr') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              N/A
            </span>
            <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('hv') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'HV is not available because we do not calculate HV for non-optionable futures, or this futures was not traded.'"
            >
              N/A
            </span>
            <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('futvolume_eod') !== -1"
              class="null-value"
            >
              0
            </span>
          </ng-container>

          <ng-container *ngSwitchCase="'frequency'">
            <ng-container [ngSwitch]="row[column.dataField]">
              <ng-container *ngSwitchCase="1">Annually</ng-container>
              <ng-container *ngSwitchCase="2">Semiannually</ng-container>
              <ng-container *ngSwitchCase="4">Quarterly</ng-container>
              <ng-container *ngSwitchCase="12">Monthly</ng-container>
              <ng-container *ngSwitchDefault></ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'iv'">
            {{ ((row[column.dataField] != 'NaN'
            && row[column.dataField] != -100) ? row[column.dataField] : null) | number:'1.0-2'}}
          </ng-container>

          <ng-container *ngSwitchCase="'mean'">
            {{ ((row[column.dataField] != 'NaN') ? row[column.dataField] : null) | number:'1.0-3'}}
          </ng-container>

          <ng-container *ngSwitchCase="'quoteTime'">
            {{getQuoteTime(row)}}
          </ng-container>

          <ng-container *ngSwitchCase="'ivx30chg'">
            <iv-live-cell
              [change]="column.ivx30"
              [showChangeValue]="true"
            >
              {{ ((row[column.dataField] != 'NaN' && row[column.dataField] != 'Infinity') ? row[column.dataField] : null) | number:'1.0-2'}}
            </iv-live-cell>
          </ng-container>

          <ng-container *ngSwitchCase="'ivx60chg'">
            <iv-live-cell
              [change]="column.ivx60"
              [showChangeValue]="true"
            >
              {{ ((row[column.dataField] != 'NaN' && row[column.dataField] != 'Infinity') ? row[column.dataField] : null) | number:'1.0-2'}}
            </iv-live-cell>
          </ng-container>

          <ng-container *ngSwitchCase="'ivx90chg'">
            <iv-live-cell
              [change]="column.ivx90"
              [showChangeValue]="true"
            >
              {{ ((row[column.dataField] != 'NaN' && row[column.dataField] != 'Infinity') ? row[column.dataField] : null) | number:'1.0-2'}}
            </iv-live-cell>
          </ng-container>

          <ng-container *ngSwitchCase="'backgroundChange'">
            <iv-live-cell
              [showChangeBackground]="true"
              [value]="row[column.dataField]"
            >
              {{ ((row[column.dataField] != 'NaN' && row[column.dataField] != 'Infinity' && row[column.dataField] != -100) ? row[column.dataField] : null) | number:'1.0-2'}}
            </iv-live-cell>
          </ng-container>

          <ng-container *ngSwitchCase="'valueChange'">
            <iv-live-cell
              [change]="row[column.dataField]"
              [showChangeValue]="true"
            >
              {{ ((row[column.dataField] != 'NaN' && row[column.dataField] != 'Infinity') ? row[column.dataField] : null) | number:'1.0-2'}}
            </iv-live-cell>
          </ng-container>

          <ng-container *ngSwitchCase="'symbol'">
            <iv-live-image-button
              statistic
              [statisticElementName]="'IVX Monitor Chart click'"
              (buttonClicked)="onChartButtonClick(row.symbol, row.stockid)"
              *ngIf='row.regionid === 1'
              [data]="row[column.dataField]"
              [tip]="'IVX Monitor'"
            >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZZJREFUeNpi/P//PwNNQe/UFQpAvJ4szesaBAgpYQLiBCAOAFlEhhXngZY0ELIgH4g/QC0ixfUg9aJAHE/IAkUgngjEC0h0PcjgOUDMBbUMuwXF2REg1zMA6QckuN4BSGoB8V4gXo7PF0xkpo16IN4EZZ8AYlOgpQakWQDy9rqG/Thcbwp1PQh8hVqWT6oP6qEum4/D9V+RxPaCE8m6BgXiLIC4kguIU4DYC54UEa7fhKbjFdwSIn0QD9UAcmUrEJdAU0o+FtfDwD5swcSExfUKUJfAwvg+ELcBcT8Qu2JxPQxcBuL36EkWmw9ghr9C07wQmiS/4ok3jMhmwhE8+7CI78XjemQ1UtC4wmLBuoYAaORepqD83Iuc8VjQJPOJcCUhAArGa5g+gEQucgaiBHzAFkT50Gz/lZr1DRNa6tnEQGUAtuAI9/t4cBqGpHnqW/CN6a8CtVyv+4NXrOOFeiGshmSsnbGk/y3zrwImBsbl1HK13C8OP2YGRm4gcwMjtOJvAFY4DVRqRAhAgxpcSzLSutkCEGAA0P5+N1GAv4UAAAAASUVORK5CYII="/>
            </iv-live-image-button>

            <div *ngIf='row.regionid !== 1'></div>
            <span
              (click)="onSymbolButtonClick(row)"
              statistic
              statisticElementName="Click symbol in monitors"
            >{{row[column.dataField]}}</span>


<!--            *ngIf="row.regionid === 1 || row.regionid === 2 || row.regionid === 3 || row.regionid === 4"-->
            <iv-live-image-button
              *ngIf="isNeedCalculators"
              statistic
              statisticElementName="Click grid calculator"
              (buttonClicked)="onCalculatorButtonClick(row)"
              [data]="row[column.dataField]"
            >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABlQAAAZUBDE2OiAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACxSURBVEiJ7ZPLDcIwEESfUbpACEE93EIRudDD1pBDuoBjyskFQRvLIUIQbxLnJwVLzM2j9e7Mjg2xwxnmJieUHDiM7FWhXDhL+U1uTJlSTGgOcMRR+GTSUrgDIBXrrg9XUWDv09bBwoh/QFsGNeqdzsbKK0rFNV5T6Dx6wAKw0+fu3nP0zyCI+DPo/snwUfN21bXvHterOHgAW8AqC+dz9wnrwJEBz4ECm8KUbMK9H8cL0RIuy8jrs/gAAAAASUVORK5CYII=">
            </iv-live-image-button>
          </ng-container>

          <ng-container *ngSwitchCase="'30hl'">
            <span *ngIf="row.ivxhigh30_eod">
              {{row.ivxhigh30_eod| number:'1.0-2'}}
              /{{row.ivxlow30_eod| number:'1.0-2'}}
            </span>
            <span *ngIf="row.ivxhigh30">
              {{row.ivxhigh30| number:'1.0-2'}}
              /{{row.ivxlow30| number:'1.0-2'}}
            </span>
              <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'60hl'">
            <span *ngIf="row.ivxhigh60_eod">{{row.ivxhigh60_eod| number:'1.0-2'}}
              /{{row.ivxlow60_eod| number:'1.0-2'}}</span>
              <span
              *ngIf="(!row.ivxhigh60_eod || !row.ivxlow60_eod) && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'90hl'">
            <span *ngIf="row.ivxhigh90_eod">{{row.ivxhigh90_eod| number:'1.0-2'}}
              /{{row.ivxlow90_eod| number:'1.0-2'}}</span>
              <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'120hl'">
            <span *ngIf="row.ivxhigh120_eod">{{row.ivxhigh120_eod| number:'1.0-2'}}
              /{{row.ivxlow120_eod| number:'1.0-2'}}</span>
              <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'150hl'">
            <span *ngIf="row.ivxhigh150_eod">{{row.ivxhigh150_eod| number:'1.0-2'}}
              /{{row.ivxlow150_eod| number:'1.0-2'}}</span>
              <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'180hl'">
            <span *ngIf="row.ivxhigh180_eod">{{row.ivxhigh180_eod| number:'1.0-2'}}
              /{{row.ivxlow180_eod| number:'1.0-2'}}</span>
              <span
              *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
              class="null-value"
              tuiHintMode="onDark"
              tuiHintDirection="bottom-left"
              [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
            >
              <div>N/A</div>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'30hldate'">
            <span *ngIf="row.ivxhighdate30_eod">{{row.ivxhighdate30_eod}}/{{row.ivxlowdate30_eod}}</span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
          >
            <div>N/A</div>
          </span>
          </ng-container>
          <ng-container *ngSwitchCase="'60hldate'">
            <span *ngIf="row.ivxhighdate60_eod">{{row.ivxhighdate60_eod}}/{{row.ivxlowdate60_eod}}</span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
          >
            <div>N/A</div>
          </span>
          </ng-container>
          <ng-container *ngSwitchCase="'90hldate'">
            <span *ngIf="row.ivxhighdate90_eod">{{row.ivxhighdate90_eod}}/{{row.ivxlowdate90_eod}}</span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
          >
            <div>N/A</div>
          </span>
          </ng-container>
          <ng-container *ngSwitchCase="'120hldate'">
            <span *ngIf="row.ivxhighdate120_eod">{{row.ivxhighdate120_eod}}/{{row.ivxlowdate120_eod}}</span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
          >
            <div>N/A</div>
          </span>
          </ng-container>
          <ng-container *ngSwitchCase="'150hldate'">
            <span *ngIf="row.ivxhighdate150_eod">{{row.ivxhighdate150_eod}}/{{row.ivxlowdate150_eod}}</span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
          >
            <div>N/A</div>
          </span>
          </ng-container>
          <ng-container *ngSwitchCase="'180hldate'">
            <span *ngIf="row.ivxhighdate180_eod">{{row.ivxhighdate180_eod}}/{{row.ivxlowdate180_eod}}</span>
            <span
            *ngIf="!row[column.dataField] && !row.stockid && column.dataField.indexOf('ivx') !== -1"
            class="null-value"
            tuiHintMode="onDark"
            tuiHintDirection="bottom-left"
            [tuiHint]="'IVX is not available because we do not calculate IVX for non-optionable futures. Please see HV for realized volatility.'"
          >
            <div>N/A</div>
          </span>
          </ng-container>

        </div>
      </div>

    </cdk-virtual-scroll-viewport>

  </div>
</div>

<div
  *ngIf="!data || !data.length"
  class="table-body-container"
  style="padding: 10px; text-align: center;"
>
  {{emptyMessage}}
</div>
